import { render, staticRenderFns } from "./call.vue?vue&type=template&id=4c2b5a8c&scoped=true"
import script from "./call.vue?vue&type=script&lang=js"
export * from "./call.vue?vue&type=script&lang=js"
import style0 from "./call.vue?vue&type=style&index=0&id=4c2b5a8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2b5a8c",
  null
  
)

export default component.exports